import { render, staticRenderFns } from "./UsagePolicyPopup.vue?vue&type=template&id=21faaac6&"
import script from "./UsagePolicyPopup.vue?vue&type=script&lang=js&"
export * from "./UsagePolicyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UsagePolicyPopup.vue"
export default component.exports